import React from 'react';
import { useTranslation } from 'react-i18next';

// assets
import { Communication, Users } from 'icons/untitledui';

// hooks
import useCanAccessConversations from 'eCoach/hooks/useCanAccessConversations';

// styles
import * as SiteOverviewStyles from 'teamLeadInsights/styles/SiteOverview.style';
import * as Text from 'theme/components/Text.style';

interface Insight {
  site: string;
  onboarding_rate: number;
  session_count: number;
}

interface CardProps {
  insight: Insight;
}

export default function SiteOverview({ insight }: CardProps): JSX.Element {
  const { t } = useTranslation('pageTeamLeadInsights');
  const canAccessConversations = useCanAccessConversations();

  return (
    <SiteOverviewStyles.Card>
      <Text.Label>{insight.site}</Text.Label>
      <SiteOverviewStyles.InsightsSection>
        <SiteOverviewStyles.Insight>
          <Text.H3>{insight.onboarding_rate}</Text.H3>
          <SiteOverviewStyles.InsightLabel>
            <Users.Users01 />
            <Text.P2Semibold>{t('insights.Onboarded')}</Text.P2Semibold>
          </SiteOverviewStyles.InsightLabel>
        </SiteOverviewStyles.Insight>
        {canAccessConversations && (
          <SiteOverviewStyles.Insight>
            <Text.H3>{insight.session_count}</Text.H3>
            <SiteOverviewStyles.InsightLabel>
              <Communication.MessageSquare02 />
              <Text.P2Semibold>
                {t('insights.Conversations submitted')}
              </Text.P2Semibold>
            </SiteOverviewStyles.InsightLabel>
          </SiteOverviewStyles.Insight>
        )}
      </SiteOverviewStyles.InsightsSection>
    </SiteOverviewStyles.Card>
  );
}
